import { useAppSelector } from './useAppStore';
import { PACKAGES_CONFIG as BASE_PACKAGES_CONFIG } from '../data';
import { getTokenDetails } from '../store/authenticate/selectors';

const useFeature = () => {
  const { subscription } = useAppSelector(getTokenDetails);

  const PACKAGES_CONFIG = { ...BASE_PACKAGES_CONFIG };

  if (!subscription?.inTrial && subscription?.subscriptionPlanName === 'free') {
    PACKAGES_CONFIG.free = { ...PACKAGES_CONFIG.lite };
  }

  const userConfig = PACKAGES_CONFIG[subscription?.subscriptionPlanName] || {};
  const userFeatures = userConfig.features || {};
  const userRoutes = userConfig.routes || [];

  /**
   * Checks if a specific feature is allowed
   * @param {string} featureKey - The key of the feature to check
   * @returns {boolean} - Whether the feature is accessible
   */
  const allowFeatureAccess = (featureKey: string): boolean => userFeatures[featureKey] || false;

  /**
   * Checks if a specific route is allowed
   * @param {string} routeKey - The key or path of the route to check
   * @returns {boolean} - Whether the route is accessible
   */
  const allowRouteAccess = (routeKey: string): boolean => userRoutes.includes(routeKey);

  return {
    allowFeatureAccess,
    allowRouteAccess,
  };
};

export { useFeature };
